import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, FlexWrapper } from 'lib/ui/components'
import { ResultItem as Result } from './../../styled'
import { useProductBySku } from 'lib/modules/catalog'

interface Props {
  sku: string
}

export const ResultItem: React.FC<Props> = ({ sku }) => {
  const history = useHistory()
  const { product } = useProductBySku({ sku })

  if (!product) {
    return null
  }

  const {
    descriptionHtml,
    name,
    customAttribute
  } = product

  const [articles] = customAttribute?.articles_url ?? []
  const [urlKey] = customAttribute?.related_products_url ?? []

  return (
    <Result>
      <h3>{name}</h3>
      <p
        dangerouslySetInnerHTML={{
          __html: descriptionHtml
        }}
      />
      <FlexWrapper wrap className='actions'>
        {articles && (
          <Button
            onClick={() => history.push(`${articles}`)}
            className='read-more'
          >
            Read More
          </Button>
        )}
        {urlKey && (
          <Button
            onClick={() => history.push(`${urlKey}`)}
            className='products'
          >
            Find Products
          </Button>
        )}
      </FlexWrapper>
    </Result>
  )
}
